module.exports = __webpack_public_path__ + "assets/a2001b240545d37de9fbbed92c13596b.png";